define('home/views/ChannelSuggestionView',[
    'backbone-marionette',

    'home/mixins/withChannelAvatar',
    'core/mixins/withChannelFollowing',
    'home/templates/channelSuggestion',
], function (
    Marionette,

    withChannelAvatar,
    withChannelFollowing,
    channelSuggestionTemplate
) {
    'use strict';

    /**
     * A view showing a single forum's avatar, name, and follow button.
     */
    var ChannelSuggestionView = Marionette.ItemView.extend({
        template: channelSuggestionTemplate,
        className: 'recommended__item',

        templateHelpers: function () {
            return {
                favicon: this.model.get('options').favicon || this.model.primaryForum.get('favicon').cache,
            };
        },
    });

    withChannelFollowing.call(ChannelSuggestionView.prototype, function () {
        return this.model;
    });

    withChannelAvatar.call(ChannelSuggestionView.prototype);

    return ChannelSuggestionView;
});

